
<v-select
    v-model    = "selected"
    :items     = "items"
    :readonly  = "readonly"
    :disabled  = "readonly"
    item-value = "id"
    item-text  = "name"
    :label     = "label"
    @change    = "onChange"
    return-object
/>
